// SVG Flag Icons for language selector
interface FlagIconProps {
  code: 'tr' | 'gb' | 'en';
  size?: number;
  className?: string;
}

export function FlagIcon({ code, size = 20, className = '' }: FlagIconProps) {
  const height = Math.round(size * 0.7);

  // Turkey Flag
  if (code === 'tr') {
    return (
      <svg
        width={size}
        height={height}
        viewBox="0 0 30 20"
        className={`rounded-sm overflow-hidden ${className}`}
      >
        <rect width="30" height="20" fill="#E30A17"/>
        <circle cx="11" cy="10" r="6" fill="white"/>
        <circle cx="12.5" cy="10" r="4.8" fill="#E30A17"/>
        <polygon points="16,10 18.5,8.5 17,10.5 19,10.5 17,11.5 18.5,13.5" fill="white"/>
      </svg>
    );
  }

  // UK/GB Flag (Union Jack)
  if (code === 'gb' || code === 'en') {
    return (
      <svg
        width={size}
        height={height}
        viewBox="0 0 60 40"
        className={`rounded-sm overflow-hidden ${className}`}
      >
        {/* Background */}
        <rect width="60" height="40" fill="#012169"/>
        {/* White diagonals */}
        <path d="M0,0 L60,40 M60,0 L0,40" stroke="white" strokeWidth="8"/>
        {/* Red diagonals */}
        <path d="M0,0 L60,40" stroke="#C8102E" strokeWidth="4"/>
        <path d="M60,0 L0,40" stroke="#C8102E" strokeWidth="4"/>
        {/* White cross */}
        <rect x="25" y="0" width="10" height="40" fill="white"/>
        <rect x="0" y="15" width="60" height="10" fill="white"/>
        {/* Red cross */}
        <rect x="27" y="0" width="6" height="40" fill="#C8102E"/>
        <rect x="0" y="17" width="60" height="6" fill="#C8102E"/>
      </svg>
    );
  }

  // Fallback - generic globe icon style
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 30 20"
      className={`rounded-sm overflow-hidden ${className}`}
    >
      <rect width="30" height="20" fill="#6B7280"/>
      <circle cx="15" cy="10" r="6" fill="none" stroke="white" strokeWidth="1"/>
      <path d="M15,4 Q12,10 15,16 Q18,10 15,4" fill="none" stroke="white" strokeWidth="1"/>
      <line x1="9" y1="10" x2="21" y2="10" stroke="white" strokeWidth="1"/>
    </svg>
  );
}
